import { render, staticRenderFns } from "./OOProfessionalServicePrice.vue?vue&type=template&id=11852216&scoped=true&"
import script from "./OOProfessionalServicePrice.vue?vue&type=script&lang=ts&"
export * from "./OOProfessionalServicePrice.vue?vue&type=script&lang=ts&"
import style0 from "./OOProfessionalServicePrice.vue?vue&type=style&index=0&id=11852216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11852216",
  null
  
)

export default component.exports